// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { EntityAttachmentsSection } from '@/components/entity-attachments-section';
import { addFulfillmentURLLink } from '@/fulfillment/api/add-fulfillment-url-link';
import { deleteFulfillmentFile } from '@/fulfillment/api/delete-fulfillment-file';
import { uploadFulfillmentFile } from '@/fulfillment/api/upload-fulfillment-file';
import { useFulfillmentFiles } from '@/fulfillment/hooks/use-fulfillment-files';
import { useFulfillmentURLLinks } from '@/fulfillment/hooks/use-fulfillment-url-links';
import {
  fulfillmentDetailQueryKey,
  fulfillmentFilesQueryKey,
  fulfillmentURLLinksQueryKey,
} from '@/fulfillment/query-keys';

interface Props {
  /** The key of the fulfillment order */
  fulfillmentKey: string;
  /** The ID of the fulfillment order (used for uploads) */
  fulfillmentId: string;
}

/**
 * Section component for displaying and managing files and URL links on the
 * fulfillment detail page. Rendered inline in the right column.
 */
export function FulfillmentAttachmentsSection(props: Props) {
  const filesData = useFulfillmentFiles({
    fulfillmentKey: props.fulfillmentKey,
  });
  const urlLinksData = useFulfillmentURLLinks({
    fulfillmentKey: props.fulfillmentKey,
  });

  return (
    <EntityAttachmentsSection
      entityKey={props.fulfillmentKey}
      entityId={props.fulfillmentId}
      ownerType="fulfillmentOrder"
      filesData={filesData}
      urlLinksData={urlLinksData}
      uploadFile={uploadFulfillmentFile}
      addURLLink={addFulfillmentURLLink}
      deleteFile={deleteFulfillmentFile}
      queryKeysToInvalidate={[
        fulfillmentDetailQueryKey(props.fulfillmentKey),
        fulfillmentFilesQueryKey(props.fulfillmentKey),
        fulfillmentURLLinksQueryKey(props.fulfillmentKey),
      ]}
    />
  );
}
